<template>
  <div>
    <contact-form
      :title="contactTitle"
      type="contact"
      hiddenName="type"
      hiddenValue="Contact from emerging.fr site"
    >
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-title">
              <h3>Thank you for contacting us! <br /></h3>
            </div>
          </div>
        </div>
      </div>
    </contact-form>
  </div>
</template>

<script>
import ContactForm from '@/components/ContactForm';
export default {
  data() {
    return {
      contactTitle: 'Feel free to contact us by filling <br /> the following form :'
    };
  },
  components: {
    ContactForm
  }
};
</script>

<style lang="scss" scoped>
.error {
  color: red;
}
</style>
